import RaidPlan from 'app/frontend/types/custom/RaidPlan'
import { useTeam } from 'app/frontend/base/config/context/team'

export const useIsDefaultRaidPlan = () => {
  const { team } = useTeam()

  return (plan: Pick<RaidPlan, 'id' | 'encounterId' | 'difficulty'>) =>
    team?.defaultRaidPlans?.[String(plan.encounterId)]?.[plan.difficulty] ===
    plan.id
}
